import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import Story from '@/components/Story'
import Projects from '@/components/Projects'
import Contact from '@/components/Contact'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/story',
      name: 'Story',
      component: Story
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js